export interface NotificationBuffer<T> {
  push(item: T): void;
  dispose(): void;
}

/**
 * Tumbling-window buffer (not a debounce). Once a window opens it runs to completion
 * so a continuous stream flushes every `windowMs`. Debounce would restart the timer
 * on every message and never flush under a steady stream.
 */
export function createNotificationBuffer<T>(
  windowMs: number,
  flush: (batch: T[]) => void
): NotificationBuffer<T> {
  let pending: T[] = [];
  let timer: ReturnType<typeof setTimeout> | null = null;

  return {
    push(item) {
      pending.push(item);
      if (timer) return; // window already open — do NOT restart it
      timer = setTimeout(() => {
        timer = null;
        const batch = pending;
        pending = [];
        flush(batch);
      }, windowMs);
    },
    dispose() {
      if (timer) clearTimeout(timer);
      timer = null;
      pending = [];
    },
  };
}
